const CraftBlockIdentityTooltip = () => {
  return (
    <button className="craft-block__title-help">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 9.16667H10V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
          stroke="rgb(117, 117, 251)"
          strokeWidth="1.6"
          strokeLinecap="square"
        />
        <rect
          x="9.33331"
          y="6"
          width="1.33333"
          height="1.33333"
          fill="rgb(117, 117, 251)"
          stroke="rgb(117, 117, 251)"
          strokeWidth="0.5"
        />
      </svg>

      <p className="craft-block__title-tooltip-text">Click to replay tutorial</p>
    </button>
  );
};

export default CraftBlockIdentityTooltip;
